import { AnalyticsMetaKeys as key } from '../../../../../services/analytics/formatters/meta-keys'
import { Utils } from '../../../../../utils/common'
import { PageEvents } from '../page-events'
import { MparticleEvent } from './mparticle-event'

const mParticleEvents: any = new PageEvents()

export class Default extends MparticleEvent {

    /**
     * Handle a widget click event
     */
    public handle(): void {

        /**
         * @var eventAttributes will be different for each
         * events
         */

        const eventAttributes = Utils.deCamelCaseKeys(this.getProperties())
        const meta = this.metaProperties || {}
        mParticleEvents.logDefaultEvent(
            {
                ...eventAttributes,
                ...{
                    [key.DOMAIN]: meta[key.DOMAIN],
                    'Event Name': this.type
                }
            }
        )
    }
}
